import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "md50k51mo__mask0_10263_46768",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#md50k51mo__mask0_10263_46768)",
        children: [_jsx("path", {
          d: "M34.0588 0H-4C-5.10457 0 -6 0.89543 -6 2V28C-6 29.1046 -5.10457 30 -4 30H34.0588C35.1634 30 36.0588 29.1046 36.0588 28V2C36.0588 0.89543 35.1634 0 34.0588 0Z",
          fill: "white"
        }), _jsx("mask", {
          id: "yfc8gms8a__mask1_10263_46768",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-6",
          y: "0",
          width: "43",
          height: "30",
          children: _jsx("path", {
            d: "M34.0588 0H-4C-5.10457 0 -6 0.89543 -6 2V28C-6 29.1046 -5.10457 30 -4 30H34.0588C35.1634 30 36.0588 29.1046 36.0588 28V2C36.0588 0.89543 35.1634 0 34.0588 0Z",
            fill: "white"
          })
        }), _jsx("g", {
          mask: "url(#yfc8gms8a__mask1_10263_46768)"
        }), _jsxs("g", {
          clipPath: "url(#kx5tx117r__clip0_10263_46768)",
          children: [_jsx("path", {
            d: "M42.1437 -3.10229H-12.1618V33.1005H42.1437V-3.10229Z",
            fill: "#005BBB"
          }), _jsx("path", {
            d: "M42.1437 15H-12.1618V33.1028H42.1437V15Z",
            fill: "#FFD500"
          })]
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      }), _jsx("defs", {
        children: _jsx("clipPath", {
          id: "kx5tx117r__clip0_10263_46768",
          children: _jsx("rect", {
            width: "53.3333",
            height: "30",
            fill: "white",
            transform: "translate(-11.6758)"
          })
        })
      })]
    }))
  });
};
export default Component;
